import axios from 'axios';
import consts from '../consts';
import { initialize } from 'redux-form';
import {
    setErroAPI,
    setSuccess
} from '../common/toast/toast';

const API = `${consts.API_URL}/analisePreco`;

export const ANALISE_PRECO_MODO_TELA =
    'ANALISE_PRECO_MODO_TELA';

export const ANALISE_PRECO_SET_AGUARDANDO =
    'ANALISE_PRECO_SET_AGUARDANDO';

export const ANALISE_PRECO_LISTADO =
    'ANALISE_PRECO_LISTADO';

const normalizarNumero = valor => {
    if (
        valor === null ||
        valor === undefined ||
        valor === ''
    ) {
        return null;
    }

    if (typeof valor === 'number') {
        return valor;
    }

    const numero = Number(
        valor
            .toString()
            .trim()
            .replace(/\./g, '')
            .replace(',', '.')
    );

    return Number.isFinite(numero)
        ? numero
        : null;
};

const normalizarRegistro = registro => ({
    ...registro,
    preco: normalizarNumero(registro.preco)
});

export function setModoTela(modo, registro = {}) {
    return {
        type: ANALISE_PRECO_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: ANALISE_PRECO_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize(
            'analisePrecoForm',
            registro
        )
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API);

            dispatch({
                type: ANALISE_PRECO_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const registroNormalizado =
                normalizarRegistro(registro);

            const request = registroNormalizado.id
                ? axios.put(
                    API,
                    registroNormalizado
                )
                : axios.post(
                    API,
                    registroNormalizado
                );

            await request;

            setSuccess(
                'Operação realizada com sucesso.'
            );

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess(
                'Operação realizada com sucesso.'
            );

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}